module.exports = __webpack_public_path__ + "img/聂庆宇.1f6585ca.jpg";